export default __webpack_public_path__ + "static/media/CCTVDropdown_white.8239d1dd.svg";